export const acceptedExt = ["csv", "xls", "xlsx", "xlsm"];
export const acceptedFiles = acceptedExt.map((name) => `.${name}`).join(", ");
